import React from "react";
import { TicketPage } from "./TicketPage";


const TicketModal: React.FunctionComponent<any> = props => {
  return (
    <>
      {/* (ticketpage.tsx - {props.index}) */}
      <TicketPage isModal={true} >
      </TicketPage>
    </>
  );
}

export default TicketModal;